/* eslint-disable no-param-reassign */
const MyCategoryTypeTranslator = {
  install (Vue) {
    Vue.getCategoryNumber = (categoryName) => {
      switch (categoryName) {
        case 'NORMAL':
          return 0
        case 'SIGNED':
          return 1
        case 'AUTOMANAGED':
          return 2
        case 'MEETING':
          return 3
      }
    }
  }
}

export default MyCategoryTypeTranslator
